import React, { useState, useEffect } from "react";
import { Modal, Button, FilePicker, } from "@veneer/core";
import { useTranslation } from "react-i18next";
import ConnectAPI from "../../../services/api";
import Swal from "sweetalert2";
const connectApi = new ConnectAPI();
function LowCoverageUpload({onShowModal, confirmationFunction,onCloseModal,showmodalagin}) {
    const [ShowModal, setShowModal] = useState(onShowModal);
    const { t, i18n } = useTranslation();
    const [FileLC,setFileLC]=useState(null);
    const [loadingbtn,setloadingbtn]=useState(false);
    function submit(){
        setloadingbtn(true);
        let data = new FormData();
        data.append("File", FileLC);
        data.append("confirm","no");
        connectApi.post(
            "api/Channels/LCFWUpload",
            data,
            handleReloadData
        ).catch((error) => {
            if(error.response.status==510){
                onCloseModal();
                Swal.fire(
                    error.response.data.message,
                    error.response.data.presses.join(" - "),
                    "error"
                );
            }
        });
    }
    function handleChangeLC(event) {
        setFileLC(event.target.files[0]);
    }
     const handleReloadData = (status,data) => {
            if (status==200){
                setloadingbtn(false);
                setFileLC(null);
                confirmationFunction();
            }else{
                loadingbtn(false);
                Swal.fire(
                    "Error " + data.status,
                    data.data,
                    "error"
                );
            }
        }
    return (<>
         <Modal
            id="regular-modal"
            onClose={() => { onCloseModal(); }}
            show={onShowModal}
            css={{
                '.vn-modal--content': {
                    width: "800px !important"
                },
                }}
            title="Low Coverage & Frame Width"
        >
                <label> Low Coverage and Framw Width File </label>
                <FilePicker
                        id="lcfile"
                        accept=".xlsx,.xls"
                        onChange={handleChangeLC}
                        label="Excel File"
                />
                <br/>
                <br/>
                <Button
                        loading={loadingbtn}
                        onClick={submit}
                        >{t("send")}</Button>
        </Modal>

    </>);
}
export default LowCoverageUpload;